<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import store from '@/store'
import '@/style/index.css' // global css

export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.$t('App.metaInfo.title'),
      meta: [
        { name: 'keywords', content: 'uzoombox,祐众私云,私云管家,安全邮箱,私有云盘,文档管理,内容管理,数据资产管理' },
        { name: 'description', content: '祐众私云 - 数据资产的私云管家' }
      ]
    }
  },
  created() {
    var locale = navigator.language.replace('-', '_')
    switch (locale) {
      case 'en_US':
      case 'zh_CN':
        // do nonthing
        break
      default:
        locale = 'en_US'
        break
    }
    this.$i18n.locale = locale
    const system = { ...store.getters['UI/System'] }
    system.Locale = locale
    store.dispatch('UI/SaveUI', { name: 'system', content: system })
  },
  mounted() {}
}
</script>
